// @ts-nocheck
/* eslint-disable */
import { boatIcon } from './boat';
import { canoeingIcon } from './canoeing';
import { chimpanzeeIcon } from './chimpanzee';
import { coffeePlantIcon } from './coffee-plant';
import { cultureIcon } from './culture';
import { horseIcon } from './horse';
import { hotAirBalloonIcon } from './hot-air-balloon';
import { hotelIcon } from './hotel';
import { landCruiserIcon } from './land-cruiser';
import { locationIcon } from './location';
import { lodgeIcon } from './lodge';
import { mealIcon } from './meal';
import { planeIcon } from './plane';
import { priceIcon } from './price';
import { routeIcon } from './route';
import { sailingIcon } from './sailing';
import { sansibarIcon } from './sansibar';
import { savannahIcon } from './savannah';
import { snorkelingIcon } from './snorkeling';
import { tentIcon } from './tent';
import { textIcon } from './text';
import { walkingSafariIcon } from './walking-safari';
export const allIcons = [boatIcon, canoeingIcon, chimpanzeeIcon, coffeePlantIcon, cultureIcon, horseIcon, hotAirBalloonIcon, hotelIcon, landCruiserIcon, locationIcon, lodgeIcon, mealIcon, planeIcon, priceIcon, routeIcon, sailingIcon, sansibarIcon, savannahIcon, snorkelingIcon, tentIcon, textIcon, walkingSafariIcon];
